<script setup lang="ts">
import { CardProps } from "./Card.props"

withDefaults(defineProps<CardProps>(), {
  path: ""
})
</script>

<template>
  <div
    class="
      banner-brand-card
      bg-white
      relative
      h-24
      w-[156px]
      transform-gpu
      rounded-lg
      drop-shadow-01
      md:h-[126px]
      md:w-auto
    "
  >
    <AppLink
      :to="path.replace('//', '/')"
      class="absolute inset-0"
      :class="[path ? 'cursor-pointer' : 'cursor-default']"
    >
      <UtilsWrapperImage
        class="wrapper-image-fit-contain overflow-hidden rounded-lg"
        v-if="image"
        sizes="200px md:300px lg:300px"
        v-bind="image"
      />
    </AppLink>
  </div>
</template>
